import { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Loader from "./Loader/Loader";
import AboutMe from "./Naime/AboutMe/AboutMe";
import Blogs from "./Naime/Blogs/Blogs";
import Contact from "./Naime/Contact/Contact";
import Home from "./Naime/Home/Home";
import MyProjects from "./Naime/MyProjects/MyProjects";
import Naime from "./Naime/Naime";
import Skills from "./Naime/Skills/Skills";


function App() {

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false)
    }, 5000)
  }, []);

  return (
    <div className="App">
      {
        loading ? <Loader></Loader> : 
      
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Naime />} >
            <Route path="/" element={<Home />} />
            <Route path="naime" element={<Home />} />
            <Route path="skills" element={<Skills />} />
            <Route path="projects" element={<MyProjects />} />
            <Route path="blog" element={<Blogs/>} />
            <Route path="about" element={<AboutMe />} />
            <Route path="contact" element={ <Contact/>} />
          </Route>
        </Routes>
      </BrowserRouter>}
    </div>
  );
}

export default App;
